module.exports = __webpack_public_path__ + "static/media/Barmag FK6 700 Driven.c1983d41.jpg";